<template>
  <FieldWrapper
    :state="state"
    :configs="configs"
  >
    <div class="column full-width q-mt-md">
      <q-btn
        dense
        outline
        color="primary"
        no-caps
        padding="6px 6px"
        icon="mdi-web"
        size="11px"
        :label="configs.buttonLabel"
        @click="openUrl"
      />
    </div>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'
const shell = window.shell

export default {
  components: {
    FieldWrapper
  },

  props: {
    state: {},
    configs: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    url () {
      return this.configs?.url
    }
  },

  methods: {
    openUrl () {
      shell.openExternal(this.url)
    }
  }
}

</script>
